import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { BusinessGiftCardBlockContainer }
  from '../../containers/BusinessGiftCardBlockContainer/BusinessGiftCardBlockContainer';
import { ContentBlocksSectionContainer }
  from '../../containers/ContentBlocksSectionContainer/ContentBlocksSectionContainer';
import { BigBottomBlockPresentational,
  FullWidthBlocksPresentational,
  ImagePresentational, LinkPresentational,
  TitleBodyImageLinkBlockPresentational,
} from '../../types/common';
import { BusinessHeroBlock } from '../BusinessHeroBlock/BusinessHeroBlock';
import {
  BusinessTopBlock,
  TitleSubtitleBlockPresentational,
} from '../BusinessTopBlock/BusinessTopBlock';
import { ContentPagesSection } from '../ContentPagesSection/ContentPagesSection';
import { Title } from '../Title/Title';

const messages = defineMessages({
  contentPagesSectionTitle: {
    id: 'src.components.BusinessPageV1.contentPagesSectionTitle',
    defaultMessage: '[[A solution for every occasion]]',
  },
});

export type Props = {
  bigBottomBlock: BigBottomBlockPresentational | null;
  blocksRows: TitleBodyImageLinkBlockPresentational[];
  fullWidthBlocks: FullWidthBlocksPresentational[];
  heroButton: LinkPresentational | null;
  heroDescription: string | null;
  heroImage: ImagePresentational | null;
  heroTitle: string;
  heroUsp: string | null;
  isDesktop: boolean;
  topBlockDescription: string | null;
  topBlockTitle: string | null;
  topBlockUsps: TitleSubtitleBlockPresentational[];
};

export const LandingPageBodyV2 = React.memo((props: Props) => {
  const {
    isDesktop,
    blocksRows,
    bigBottomBlock,
    fullWidthBlocks,
    heroButton,
    heroDescription,
    heroImage,
    heroTitle,
    heroUsp,
    topBlockDescription,
    topBlockTitle,
    topBlockUsps,
  } = props;

  return (
    <>
      <BusinessHeroBlock
        heroTitle={heroTitle}
        heroImage={heroImage}
        heroDescription={heroDescription}
        heroUsp={heroUsp}
        heroButton={heroButton}
        isDesktop={isDesktop}
      />
      <BusinessTopBlock
        topBlockTitle={topBlockTitle}
        topBlockDescription={topBlockDescription}
        topBlockUsps={topBlockUsps}
      />
      <ContentBlocksSectionContainer items={fullWidthBlocks} />
      <ContentPagesSection
        items={blocksRows}
        title={<Title title={<FormattedMessage {...messages.contentPagesSectionTitle} />} />}
      />
      {bigBottomBlock && (
        <BusinessGiftCardBlockContainer data={bigBottomBlock} />
      )}
    </>
  );
});

LandingPageBodyV2.displayName = 'LandingPageBodyV2';
